import React from "react";
import { Box, Typography, Link, Grid } from "@mui/material";
import { FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa";

const Footer = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#333",
        color: "white",
        padding: "20px 20px",
        marginTop: "auto",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Grid
        container
        spacing={3}
        justifyContent="center"
        sx={{
          textAlign: "center",
        }}
      >
        <Grid
          item
          xs={12}
          sm={4}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Link to="/" style={{ textDecoration: "none" }}>
            <img src="/assets/logo2.png" alt="Logo" height={120} width={120} />
          </Link>
        </Grid>

        <Grid item xs={12} sm={4}>
          <Typography variant="h6" gutterBottom>
            Useful Links
          </Typography>
          
          <Link
            sx={{ fontSize: 13 }}
            href="/Customers"
            color="inherit"
            underline="hover"
          >
            Products For Consumers
          </Link>
          <br />
          <Link
            sx={{ fontSize: 13 }}
            href="/Consumers"
            color="inherit"
            underline="hover"
          >
            Products For Farmers
          </Link>
          <br />
          <Link
            sx={{ fontSize: 13 }}
            href="/Contact"
            color="inherit"
            underline="hover"
          >
            Contact Us
          </Link>
        </Grid>

        <Grid
          item
          xs={12}
          sm={4}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Typography variant="h6" gutterBottom>
            Social
          </Typography>
          <Link
            sx={{ fontSize: 13 }}
            href="https://www.facebook.com"
            color="inherit"
            underline="hover"
          >
            <FaFacebook size={13} /> Facebook
          </Link>

          <br />
          <Link
            sx={{ fontSize: 13 }}
            href="https://www.instagram.com"
            color="inherit"
            underline="hover"
          >
            <FaInstagram size={13} /> Instagram
          </Link>
        </Grid>
      </Grid>
      <Box
        sx={{ marginTop: "20px", width: "100%", borderTop: "1px solid white" }}
      ></Box>

      <Box sx={{ marginTop: "20px", textAlign: "center" }}>
        <Typography variant="body2">
          &copy; {new Date().getFullYear()} WestValleyOrganicFarm | All rights
          reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
